"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "core-color-neutral-white": "#FFFFFF",
    "core-color-neutral-black": "#000000",
    "core-color-slate-0": "#F5FAFA",
    "core-color-slate-5": "#EDF2F2",
    "core-color-slate-10": "#DFE8E8",
    "core-color-slate-20": "#C9D4D4",
    "core-color-slate-30": "#B0BFBF",
    "core-color-slate-40": "#9AABAB",
    "core-color-slate-50": "#869191",
    "core-color-slate-60": "#697070",
    "core-color-slate-70": "#545959",
    "core-color-slate-80": "#434747",
    "core-color-slate-90": "#303333",
    "core-color-slate-100": "#242626",
    "core-color-blue-0": "#FAFBFC",
    "core-color-blue-5": "#E3EFFC",
    "core-color-blue-10": "#D6E8FC",
    "core-color-blue-20": "#AACEF7",
    "core-color-blue-30": "#7EB2EE",
    "core-color-blue-40": "#5696E0",
    "core-color-blue-50": "#347BCF",
    "core-color-blue-60": "#1C64B9",
    "core-color-blue-70": "#094E9E",
    "core-color-blue-80": "#053E81",
    "core-color-blue-90": "#023065",
    "core-color-blue-100": "#00244D",
    "core-color-green-0": "#F7FFFA",
    "core-color-green-5": "#E1FAE4",
    "core-color-green-10": "#D0E7D4",
    "core-color-green-20": "#A5D4AE",
    "core-color-green-30": "#7DC089",
    "core-color-green-40": "#5CAC6B",
    "core-color-green-50": "#429952",
    "core-color-green-60": "#308540",
    "core-color-green-70": "#186E28",
    "core-color-green-80": "#0C571A",
    "core-color-green-90": "#054010",
    "core-color-green-100": "#003309",
    "core-color-yellow-0": "#FFFFF0",
    "core-color-yellow-5": "#FAFAE3",
    "core-color-yellow-10": "#F0F0C9",
    "core-color-yellow-20": "#E8E8B1",
    "core-color-yellow-30": "#DEDE96",
    "core-color-yellow-40": "#C7C775",
    "core-color-yellow-50": "#B0B058",
    "core-color-yellow-60": "#72723F",
    "core-color-yellow-70": "#545437",
    "core-color-yellow-80": "#3D3D2B",
    "core-color-yellow-90": "#2E2E22",
    "core-color-yellow-100": "#21211A",
    "core-color-orange-0": "#FFFCF0",
    "core-color-orange-5": "#F7F2DA",
    "core-color-orange-10": "#F7EFCD",
    "core-color-orange-20": "#F2D562",
    "core-color-orange-30": "#E9C63D",
    "core-color-orange-40": "#DCB20D",
    "core-color-orange-50": "#CAA200",
    "core-color-orange-60": "#B38F00",
    "core-color-orange-70": "#8C7000",
    "core-color-orange-80": "#695300",
    "core-color-orange-90": "#4D3D00",
    "core-color-orange-100": "#382D00",
    "core-color-red-0": "#FCF7F7",
    "core-color-red-5": "#F2E6E8",
    "core-color-red-10": "#FFD2D9",
    "core-color-red-20": "#FFA3B0",
    "core-color-red-30": "#FF7A8D",
    "core-color-red-40": "#FD5971",
    "core-color-red-50": "#E03850",
    "core-color-red-60": "#C42137",
    "core-color-red-70": "#A71226",
    "core-color-red-80": "#8B091A",
    "core-color-red-90": "#6E0411",
    "core-color-red-100": "#52020B",
    "core-color-light-blue-0": "#F6FBFC",
    "core-color-light-blue-5": "#D9F0FA",
    "core-color-light-blue-10": "#CADFE7",
    "core-color-light-blue-20": "#9DC6D7",
    "core-color-light-blue-30": "#6FB3CF",
    "core-color-light-blue-40": "#449DC3",
    "core-color-light-blue-50": "#2086B1",
    "core-color-light-blue-60": "#09709C",
    "core-color-light-blue-70": "#065E83",
    "core-color-light-blue-80": "#034A68",
    "core-color-light-blue-90": "#01374E",
    "core-color-light-blue-100": "#002738",
    "core-color-teal-0": "#F5FCFC",
    "core-color-teal-5": "#DCF7F5",
    "core-color-teal-10": "#B6E4E1",
    "core-color-teal-20": "#80D0CB",
    "core-color-teal-30": "#51BBB5",
    "core-color-teal-40": "#2CA6A0",
    "core-color-teal-50": "#10928B",
    "core-color-teal-60": "#007D76",
    "core-color-teal-70": "#006962",
    "core-color-teal-80": "#00544E",
    "core-color-teal-90": "#004645",
    "core-color-teal-100": "#00373A",
    "core-space-none": "0px",
    "core-space-xxxs": "0.125rem",
    "core-space-xxs": "0.25rem",
    "core-space-xs": "0.5rem",
    "core-space-sm": "0.75rem",
    "core-space-base": "1rem",
    "core-space-lg": "1.25rem",
    "core-space-xl": "1.5rem",
    "core-space-2xl": "2rem",
    "core-space-3xl": "2.5rem",
    "core-space-4xl": "3rem",
    "core-space-5xl": "3.5rem",
    "core-space-6xl": "4rem",
    "core-space-7xl": "4.5rem",
    "core-space-8xl": "6rem",
    "core-space-9xl": "8rem",
    "core-space-10xl": "10rem",
    "core-space-11xl": "12rem",
    "core-space-12xl": "14rem",
    "core-space-13xl": "16rem",
    "core-space-14xl": "18rem",
    "core-font-size-xxs": "10px",
    "core-font-size-xs": "12px",
    "core-font-size-sm": "14px",
    "core-font-size-base": "16px",
    "core-font-size-lg": "18px",
    "core-font-size-xl": "20px",
    "core-font-size-2xl": "24px",
    "core-font-size-3xl": "30px",
    "core-font-size-4xl": "36px",
    "core-font-size-5xl": "48px",
    "core-font-size-6xl": "60px",
    "core-font-size-7xl": "72px",
    "core-font-size-8xl": "96px",
    "core-font-size-9xl": "128px",
    "core-font-family-sans": "Gilroy",
    "core-font-family-serif": "P22 Mackinac Pro",
    "core-font-weight-1-base": 500,
    "core-font-weight-1-italic": 500,
    "core-font-weight-2-base": 600,
    "core-font-weight-2-italic": 600,
    "core-font-weight-3-base": 700,
    "core-font-weight-3-italic": 700,
    "core-line-height-none": "100%",
    "core-line-height-tight": "130%",
    "core-line-height-heading": "140%",
    "core-line-height-body-sm": "20px",
    "core-line-height-body-md": "24px",
    "core-line-height-body-lg": "28px",
    "core-line-height-label": "20px",
    "core-line-height-caption": "16px",
    "core-border-radius-xxs": "4px",
    "core-border-radius-xs": "8px",
    "core-border-radius-sm": "10px",
    "core-border-radius-md": "12px",
    "core-border-radius-lg": "16px",
    "core-border-radius-xl": "20px",
    "core-border-radius-2xl": "32px",
    "core-border-radius-max": "999px",
    "core-size-xs": "0.5rem",
    "core-size-sm": "0.75rem",
    "core-size-base": "1rem",
    "core-size-lg": "1.25rem",
    "core-size-xl": "1.5rem",
    "core-size-2xl": "2rem",
    "core-size-3xl": "2.5rem",
    "core-size-4xl": "3rem",
    "core-size-5xl": "3.5rem",
    "core-size-6xl": "4rem",
    "core-size-7xl": "4.5rem",
    "core-size-8xl": "5rem",
    "core-letter-spacing-tighter": "-0.75px",
    "core-letter-spacing-tight": "-0.25px",
    "core-letter-spacing-base": "0px",
    "core-letter-spacing-wide": "0.25px",
    "core-letter-spacing-wider": "0.75px",
    "core-letter-spacing-widest": "1.25px",
    "core-border-width-0": "0px",
    "core-border-width-1": "1px",
    "core-border-width-2": "1.5px",
    "core-border-width-3": "2px",
    "core-shadow-border-hover-x": 0,
    "core-shadow-border-hover-y": 0,
    "core-shadow-border-hover-blur": 0,
    "core-shadow-border-hover-spread": 5,
    "core-shadow-border-hover-color": "rgba({core-color-slate-100},0.05)",
    "core-shadow-border-hover-type": "dropShadow",
    "core-shadow-border-pressed-x": 0,
    "core-shadow-border-pressed-y": 0,
    "core-shadow-border-pressed-blur": 0,
    "core-shadow-border-pressed-spread": 8,
    "core-shadow-border-pressed-color": "rgba({core-color-slate-100},0.05)",
    "core-shadow-border-pressed-type": "dropShadow",
    "core-shadow-focused-default-0-x": 0,
    "core-shadow-focused-default-0-y": 0,
    "core-shadow-focused-default-0-blur": 0,
    "core-shadow-focused-default-0-spread": 2,
    "core-shadow-focused-default-0-color": "{core-color-neutral-white}",
    "core-shadow-focused-default-0-type": "dropShadow",
    "core-shadow-focused-default-1-x": 0,
    "core-shadow-focused-default-1-y": 0,
    "core-shadow-focused-default-1-blur": 0,
    "core-shadow-focused-default-1-spread": 4,
    "core-shadow-focused-default-1-color": "{alias-color-bg-primary}",
    "core-shadow-focused-default-1-type": "dropShadow",
    "core-shadow-elevation-1-0-x": 0,
    "core-shadow-elevation-1-0-y": 1,
    "core-shadow-elevation-1-0-blur": 2,
    "core-shadow-elevation-1-0-spread": 0,
    "core-shadow-elevation-1-0-color": "rgba({core-color-slate-80},0.05)",
    "core-shadow-elevation-1-0-type": "dropShadow",
    "core-shadow-elevation-2-0-x": 0,
    "core-shadow-elevation-2-0-y": 2,
    "core-shadow-elevation-2-0-blur": 4,
    "core-shadow-elevation-2-0-spread": -1,
    "core-shadow-elevation-2-0-color": "rgba({core-color-slate-80},0.06)",
    "core-shadow-elevation-2-0-type": "dropShadow",
    "core-shadow-elevation-3-0-x": 0,
    "core-shadow-elevation-3-0-y": 16,
    "core-shadow-elevation-3-0-blur": 20,
    "core-shadow-elevation-3-0-spread": -2,
    "core-shadow-elevation-3-0-color": "rgba({core-color-slate-80},0.04)",
    "core-shadow-elevation-3-0-type": "dropShadow",
    "core-shadow-elevation-3-1-x": 0,
    "core-shadow-elevation-3-1-y": 2,
    "core-shadow-elevation-3-1-blur": 4,
    "core-shadow-elevation-3-1-spread": -2,
    "core-shadow-elevation-3-1-color": "rgba({core-color-slate-80},0.04)",
    "core-shadow-elevation-3-1-type": "dropShadow",
    "core-shadow-elevation-4-0-x": 0,
    "core-shadow-elevation-4-0-y": 20,
    "core-shadow-elevation-4-0-blur": 24,
    "core-shadow-elevation-4-0-spread": -2,
    "core-shadow-elevation-4-0-color": "rgba({core-color-slate-80},0.05)",
    "core-shadow-elevation-4-0-type": "dropShadow",
    "core-shadow-elevation-4-1-x": 0,
    "core-shadow-elevation-4-1-y": 4,
    "core-shadow-elevation-4-1-blur": 6,
    "core-shadow-elevation-4-1-spread": -2,
    "core-shadow-elevation-4-1-color": "rgba({core-color-slate-80},0.03)",
    "core-shadow-elevation-4-1-type": "dropShadow",
    "core-shadow-elevation-5-0-x": 0,
    "core-shadow-elevation-5-0-y": 30,
    "core-shadow-elevation-5-0-blur": 32,
    "core-shadow-elevation-5-0-spread": -4,
    "core-shadow-elevation-5-0-color": "rgba({core-color-slate-80},0.06)",
    "core-shadow-elevation-5-0-type": "dropShadow",
    "core-shadow-elevation-5-1-x": 0,
    "core-shadow-elevation-5-1-y": 8,
    "core-shadow-elevation-5-1-blur": 8,
    "core-shadow-elevation-5-1-spread": -6,
    "core-shadow-elevation-5-1-color": "rgba({core-color-slate-80},0.03)",
    "core-shadow-elevation-5-1-type": "dropShadow",
    "core-shadow-elevation-6-0-x": 0,
    "core-shadow-elevation-6-0-y": 40,
    "core-shadow-elevation-6-0-blur": 40,
    "core-shadow-elevation-6-0-spread": -12,
    "core-shadow-elevation-6-0-color": "rgba({core-color-slate-80},0.08)",
    "core-shadow-elevation-6-0-type": "dropShadow",
    "core-shadow-elevation-6-1-x": 0,
    "core-shadow-elevation-6-1-y": 8,
    "core-shadow-elevation-6-1-blur": 8,
    "core-shadow-elevation-6-1-spread": -4,
    "core-shadow-elevation-6-1-color": "rgba({core-color-slate-80},0.03)",
    "core-shadow-elevation-6-1-type": "dropShadow",
    "core-shadow-elevation-dark-bg-1-0-x": 0,
    "core-shadow-elevation-dark-bg-1-0-y": 1,
    "core-shadow-elevation-dark-bg-1-0-blur": 2,
    "core-shadow-elevation-dark-bg-1-0-spread": 0,
    "core-shadow-elevation-dark-bg-1-0-color": "rgba({core-color-slate-80},0.15)",
    "core-shadow-elevation-dark-bg-1-0-type": "dropShadow",
    "core-shadow-elevation-dark-bg-2-0-x": 0,
    "core-shadow-elevation-dark-bg-2-0-y": 2,
    "core-shadow-elevation-dark-bg-2-0-blur": 4,
    "core-shadow-elevation-dark-bg-2-0-spread": -1,
    "core-shadow-elevation-dark-bg-2-0-color": "rgba({core-color-slate-80},0.20)",
    "core-shadow-elevation-dark-bg-2-0-type": "dropShadow",
    "core-shadow-elevation-dark-bg-3-0-x": 0,
    "core-shadow-elevation-dark-bg-3-0-y": 16,
    "core-shadow-elevation-dark-bg-3-0-blur": 24,
    "core-shadow-elevation-dark-bg-3-0-spread": -2,
    "core-shadow-elevation-dark-bg-3-0-color": "rgba({core-color-slate-80},0.23)",
    "core-shadow-elevation-dark-bg-3-0-type": "dropShadow",
    "core-shadow-elevation-dark-bg-3-1-x": 0,
    "core-shadow-elevation-dark-bg-3-1-y": 2,
    "core-shadow-elevation-dark-bg-3-1-blur": 6,
    "core-shadow-elevation-dark-bg-3-1-spread": -2,
    "core-shadow-elevation-dark-bg-3-1-color": "rgba({core-color-slate-80},0.23)",
    "core-shadow-elevation-dark-bg-3-1-type": "dropShadow",
    "core-shadow-elevation-dark-bg-4-0-x": 0,
    "core-shadow-elevation-dark-bg-4-0-y": 20,
    "core-shadow-elevation-dark-bg-4-0-blur": 28,
    "core-shadow-elevation-dark-bg-4-0-spread": -2,
    "core-shadow-elevation-dark-bg-4-0-color": "rgba({core-color-slate-80},0.25)",
    "core-shadow-elevation-dark-bg-4-0-type": "dropShadow",
    "core-shadow-elevation-dark-bg-4-1-x": 0,
    "core-shadow-elevation-dark-bg-4-1-y": 4,
    "core-shadow-elevation-dark-bg-4-1-blur": 12,
    "core-shadow-elevation-dark-bg-4-1-spread": -2,
    "core-shadow-elevation-dark-bg-4-1-color": "rgba({core-color-slate-80},0.25)",
    "core-shadow-elevation-dark-bg-4-1-type": "dropShadow",
    "core-shadow-elevation-dark-bg-5-0-x": 0,
    "core-shadow-elevation-dark-bg-5-0-y": 36,
    "core-shadow-elevation-dark-bg-5-0-blur": 32,
    "core-shadow-elevation-dark-bg-5-0-spread": -4,
    "core-shadow-elevation-dark-bg-5-0-color": "rgba({core-color-slate-80},0.27)",
    "core-shadow-elevation-dark-bg-5-0-type": "dropShadow",
    "core-shadow-elevation-dark-bg-5-1-x": 0,
    "core-shadow-elevation-dark-bg-5-1-y": 8,
    "core-shadow-elevation-dark-bg-5-1-blur": 10,
    "core-shadow-elevation-dark-bg-5-1-spread": -6,
    "core-shadow-elevation-dark-bg-5-1-color": "rgba({core-color-slate-80},0.25)",
    "core-shadow-elevation-dark-bg-5-1-type": "dropShadow",
    "core-shadow-elevation-dark-bg-6-0-x": 0,
    "core-shadow-elevation-dark-bg-6-0-y": 40,
    "core-shadow-elevation-dark-bg-6-0-blur": 44,
    "core-shadow-elevation-dark-bg-6-0-spread": -12,
    "core-shadow-elevation-dark-bg-6-0-color": "rgba({core-color-slate-80},0.34)",
    "core-shadow-elevation-dark-bg-6-0-type": "dropShadow",
    "core-shadow-elevation-dark-bg-6-1-x": 0,
    "core-shadow-elevation-dark-bg-6-1-y": 8,
    "core-shadow-elevation-dark-bg-6-1-blur": 12,
    "core-shadow-elevation-dark-bg-6-1-spread": -4,
    "core-shadow-elevation-dark-bg-6-1-color": "rgba({core-color-slate-80},0.28)",
    "core-shadow-elevation-dark-bg-6-1-type": "dropShadow",
    "core-shadow-elevation-inverse-1-0-x": 0,
    "core-shadow-elevation-inverse-1-0-y": -1,
    "core-shadow-elevation-inverse-1-0-blur": 2,
    "core-shadow-elevation-inverse-1-0-spread": 0,
    "core-shadow-elevation-inverse-1-0-color": "rgba({core-color-slate-80},0.05)",
    "core-shadow-elevation-inverse-1-0-type": "dropShadow",
    "core-shadow-elevation-inverse-2-0-x": 0,
    "core-shadow-elevation-inverse-2-0-y": -2,
    "core-shadow-elevation-inverse-2-0-blur": 4,
    "core-shadow-elevation-inverse-2-0-spread": -1,
    "core-shadow-elevation-inverse-2-0-color": "rgba({core-color-slate-80},0.06)",
    "core-shadow-elevation-inverse-2-0-type": "dropShadow",
    "core-shadow-elevation-inverse-3-0-x": 0,
    "core-shadow-elevation-inverse-3-0-y": -16,
    "core-shadow-elevation-inverse-3-0-blur": 20,
    "core-shadow-elevation-inverse-3-0-spread": -2,
    "core-shadow-elevation-inverse-3-0-color": "rgba({core-color-slate-80},0.04)",
    "core-shadow-elevation-inverse-3-0-type": "dropShadow",
    "core-shadow-elevation-inverse-3-1-x": 0,
    "core-shadow-elevation-inverse-3-1-y": -2,
    "core-shadow-elevation-inverse-3-1-blur": 4,
    "core-shadow-elevation-inverse-3-1-spread": -2,
    "core-shadow-elevation-inverse-3-1-color": "rgba({core-color-slate-80},0.04)",
    "core-shadow-elevation-inverse-3-1-type": "dropShadow",
    "core-shadow-elevation-inverse-4-0-x": 0,
    "core-shadow-elevation-inverse-4-0-y": -20,
    "core-shadow-elevation-inverse-4-0-blur": 24,
    "core-shadow-elevation-inverse-4-0-spread": -2,
    "core-shadow-elevation-inverse-4-0-color": "rgba({core-color-slate-80},0.05)",
    "core-shadow-elevation-inverse-4-0-type": "dropShadow",
    "core-shadow-elevation-inverse-4-1-x": 0,
    "core-shadow-elevation-inverse-4-1-y": -4,
    "core-shadow-elevation-inverse-4-1-blur": 6,
    "core-shadow-elevation-inverse-4-1-spread": -2,
    "core-shadow-elevation-inverse-4-1-color": "rgba({core-color-slate-80},0.03)",
    "core-shadow-elevation-inverse-4-1-type": "dropShadow",
    "core-shadow-elevation-inverse-5-0-x": 0,
    "core-shadow-elevation-inverse-5-0-y": -30,
    "core-shadow-elevation-inverse-5-0-blur": 32,
    "core-shadow-elevation-inverse-5-0-spread": -4,
    "core-shadow-elevation-inverse-5-0-color": "rgba({core-color-slate-80},0.06)",
    "core-shadow-elevation-inverse-5-0-type": "dropShadow",
    "core-shadow-elevation-inverse-5-1-x": 0,
    "core-shadow-elevation-inverse-5-1-y": -8,
    "core-shadow-elevation-inverse-5-1-blur": 8,
    "core-shadow-elevation-inverse-5-1-spread": -6,
    "core-shadow-elevation-inverse-5-1-color": "rgba({core-color-slate-80},0.03)",
    "core-shadow-elevation-inverse-5-1-type": "dropShadow",
    "core-shadow-elevation-inverse-6-0-x": 0,
    "core-shadow-elevation-inverse-6-0-y": -40,
    "core-shadow-elevation-inverse-6-0-blur": 40,
    "core-shadow-elevation-inverse-6-0-spread": -12,
    "core-shadow-elevation-inverse-6-0-color": "rgba({core-color-slate-80},0.08)",
    "core-shadow-elevation-inverse-6-0-type": "dropShadow",
    "core-shadow-elevation-inverse-6-1-x": 0,
    "core-shadow-elevation-inverse-6-1-y": -8,
    "core-shadow-elevation-inverse-6-1-blur": 8,
    "core-shadow-elevation-inverse-6-1-spread": -4,
    "core-shadow-elevation-inverse-6-1-color": "rgba({core-color-slate-80},0.03)",
    "core-shadow-elevation-inverse-6-1-type": "dropShadow",
    "core-letter-case-uppercase": "uppercase",
    "core-divider-right-x": 1,
    "core-divider-right-y": 0,
    "core-divider-right-blur": 0,
    "core-divider-right-spread": 0,
    "core-divider-right-color": "{alias-color-border-base}",
    "core-divider-right-type": "dropShadow",
    "core-divider-left-x": -1,
    "core-divider-left-y": 0,
    "core-divider-left-blur": 0,
    "core-divider-left-spread": 0,
    "core-divider-left-color": "{alias-color-border-base}",
    "core-divider-left-type": "dropShadow",
    "core-divider-top-x": 0,
    "core-divider-top-y": -1,
    "core-divider-top-blur": 0,
    "core-divider-top-spread": 0,
    "core-divider-top-color": "{alias-color-border-base}",
    "core-divider-top-type": "dropShadow",
    "core-divider-bottom-x": 0,
    "core-divider-bottom-y": 1,
    "core-divider-bottom-blur": 0,
    "core-divider-bottom-spread": 0,
    "core-divider-bottom-color": "{alias-color-border-base}",
    "core-divider-bottom-type": "dropShadow",
    "core-text-decoration-underline": "underline",
    "core-filter-backdrop-brightness-darken-1": 0.97,
    "core-filter-backdrop-brightness-darken-2": 0.94,
    "core-image-placeholder-landscape-1": "https://images.unsplash.com/photo-1606788075819-9574a6edfab3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2068&q=80",
    "alias-border-radius-pill": "{core-border-radius-max}",
    "alias-border-radius-circle": "{core-border-radius-max}",
    "alias-color-bg-base": "{core-color-neutral-white}",
    "alias-color-bg-alt": "{core-color-slate-0}",
    "alias-color-bg-neutral": "{core-color-slate-5}",
    "alias-color-bg-accent": "{core-color-light-blue-60}",
    "alias-color-bg-accent-weak": "{core-color-light-blue-5}",
    "alias-color-bg-info": "{core-color-light-blue-60}",
    "alias-color-bg-info-weak": "{core-color-light-blue-5}",
    "alias-color-bg-success": "{core-color-green-60}",
    "alias-color-bg-success-weak": "{core-color-green-5}",
    "alias-color-bg-attention": "{core-color-orange-30}",
    "alias-color-bg-attention-weak": "{core-color-orange-5}",
    "alias-color-bg-critical": "{core-color-red-60}",
    "alias-color-bg-critical-weak": "{core-color-red-5}",
    "alias-color-bg-primary": "{alias-color-brand-primary}",
    "alias-color-bg-primary-weak": "{core-color-teal-5}",
    "alias-color-bg-secondary": "{core-color-light-blue-20}",
    "alias-color-bg-tertiary": "{core-color-blue-5}",
    "alias-color-bg-disabled": "{core-color-slate-5}",
    "alias-color-bg-base-inverse": "{core-color-slate-90}",
    "alias-color-text-base": "{core-color-slate-90}",
    "alias-color-text-weak": "{core-color-slate-80}",
    "alias-color-text-weaker": "{core-color-slate-70}",
    "alias-color-text-weakest": "{core-color-slate-60}",
    "alias-color-text-disabled": "{core-color-slate-30}",
    "alias-color-text-link-default": "{core-color-light-blue-60}",
    "alias-color-text-link-hover": "{core-color-light-blue-70}",
    "alias-color-text-link-pressed": "{core-color-light-blue-80}",
    "alias-color-text-link-visited": "{core-color-slate-60}",
    "alias-color-text-info": "{core-color-light-blue-60}",
    "alias-color-text-success": "{core-color-green-60}",
    "alias-color-text-attention": "{core-color-orange-60}",
    "alias-color-text-critical": "{core-color-red-70}",
    "alias-color-text-accent": "{core-color-light-blue-60}",
    "alias-color-border-base": "{core-color-slate-20}",
    "alias-color-border-weak": "{core-color-slate-10}",
    "alias-color-border-hover": "{core-color-slate-20}",
    "alias-color-border-pressed": "{core-color-slate-30}",
    "alias-color-border-active": "{core-color-teal-80}",
    "alias-color-border-accent": "{core-color-light-blue-60}",
    "alias-color-border-critical": "{core-color-red-60}",
    "alias-color-border-disabled": "{core-color-slate-5}",
    "alias-color-border-base-inverse": "{core-color-slate-10}",
    "alias-color-border-weak-inverse": "{core-color-slate-5}",
    "alias-color-border-active-inverse": "{core-color-slate-5}",
    "alias-color-icon-base": "{core-color-slate-50}",
    "alias-color-icon-weak": "{core-color-slate-40}",
    "alias-color-icon-disabled": "{core-color-slate-20}",
    "alias-color-icon-accent": "{core-color-light-blue-50}",
    "alias-color-icon-primary": "{core-color-teal-80}",
    "alias-color-icon-info": "{core-color-light-blue-50}",
    "alias-color-icon-success": "{core-color-green-50}",
    "alias-color-icon-attention": "{core-color-orange-50}",
    "alias-color-icon-critical": "{core-color-red-60}",
    "alias-color-text-on-primary": "{core-color-light-blue-5}",
    "alias-color-text-on-primary-variant": "{core-color-light-blue-10}",
    "alias-color-text-on-secondary": "{core-color-light-blue-80}",
    "alias-color-text-on-tertiary": "{core-color-blue-70}",
    "alias-color-text-on-destructive": "{core-color-red-60}",
    "alias-color-text-on-info": "{core-color-neutral-white}",
    "alias-color-text-on-info-weak": "{core-color-light-blue-80}",
    "alias-color-text-on-success": "{core-color-neutral-white}",
    "alias-color-text-on-success-weak": "{core-color-green-80}",
    "alias-color-text-on-attention": "{core-color-orange-100}",
    "alias-color-text-on-attention-weak": "{core-color-orange-90}",
    "alias-color-text-on-critical": "{core-color-neutral-white}",
    "alias-color-text-on-critical-weak": "{core-color-red-80}",
    "alias-color-text-on-neutral": "{core-color-slate-70}",
    "alias-color-text-on-outline": "{alias-color-text-weaker}",
    "alias-color-text-on-base-inverse": "{core-color-neutral-white}",
    "alias-color-text-on-base-active": "{core-color-teal-80}",
    "alias-color-text-on-accent": "{core-color-neutral-white}",
    "alias-color-text-on-outline-active": "{core-color-teal-80}",
    "alias-color-brand-primary": "{core-color-teal-80}",
    "alias-color-brand-secondary": "{core-color-teal-100}",
    "alias-color-brand-tertiary": "{core-color-light-blue-20}",
    "alias-color-brand-health-primary": "{core-color-blue-60}",
    "alias-color-brand-insurance-primary": "{core-color-green-60}",
    "alias-color-brand-cares-primary": "{core-color-red-40}",
    "alias-font-display-sans-2xl-font-family": "{core-font-family-sans}",
    "alias-font-display-sans-2xl-font-weight": "{core-font-weight-2-base}",
    "alias-font-display-sans-2xl-line-height": "{core-line-height-heading}",
    "alias-font-display-sans-2xl-font-size": "{core-font-size-5xl}",
    "alias-font-display-sans-2xl-letter-spacing": "0%",
    "alias-font-display-sans-2xl-paragraph-spacing": 0,
    "alias-font-display-sans-2xl-text-decoration": "none",
    "alias-font-display-sans-2xl-text-case": "none",
    "alias-font-display-sans-xl-font-family": "{core-font-family-sans}",
    "alias-font-display-sans-xl-font-weight": "{core-font-weight-2-base}",
    "alias-font-display-sans-xl-line-height": "{core-line-height-heading}",
    "alias-font-display-sans-xl-font-size": "{core-font-size-4xl}",
    "alias-font-display-sans-xl-letter-spacing": "0%",
    "alias-font-display-sans-xl-paragraph-spacing": 0,
    "alias-font-display-sans-xl-text-decoration": "none",
    "alias-font-display-sans-xl-text-case": "none",
    "alias-font-display-sans-lg-font-family": "{core-font-family-sans}",
    "alias-font-display-sans-lg-font-weight": "{core-font-weight-2-base}",
    "alias-font-display-sans-lg-line-height": "{core-line-height-heading}",
    "alias-font-display-sans-lg-font-size": "{core-font-size-3xl}",
    "alias-font-display-sans-lg-letter-spacing": "0%",
    "alias-font-display-sans-lg-paragraph-spacing": 0,
    "alias-font-display-sans-lg-text-decoration": "none",
    "alias-font-display-sans-lg-text-case": "none",
    "alias-font-display-sans-md-font-family": "{core-font-family-sans}",
    "alias-font-display-sans-md-font-weight": "{core-font-weight-2-base}",
    "alias-font-display-sans-md-line-height": "{core-line-height-heading}",
    "alias-font-display-sans-md-font-size": "{core-font-size-2xl}",
    "alias-font-display-sans-md-letter-spacing": "0%",
    "alias-font-display-sans-md-paragraph-spacing": 0,
    "alias-font-display-sans-md-text-decoration": "none",
    "alias-font-display-sans-md-text-case": "none",
    "alias-font-display-sans-sm-font-family": "{core-font-family-sans}",
    "alias-font-display-sans-sm-font-weight": "{core-font-weight-2-base}",
    "alias-font-display-sans-sm-line-height": "{core-line-height-heading}",
    "alias-font-display-sans-sm-font-size": "{core-font-size-lg}",
    "alias-font-display-sans-sm-letter-spacing": "0%",
    "alias-font-display-sans-sm-paragraph-spacing": 0,
    "alias-font-display-sans-sm-text-decoration": "none",
    "alias-font-display-sans-sm-text-case": "none",
    "alias-font-display-serif-2xl-font-family": "{core-font-family-serif}",
    "alias-font-display-serif-2xl-font-weight": "{core-font-weight-1-base}",
    "alias-font-display-serif-2xl-line-height": "{core-line-height-heading}",
    "alias-font-display-serif-2xl-font-size": "{core-font-size-5xl}",
    "alias-font-display-serif-2xl-letter-spacing": "0%",
    "alias-font-display-serif-2xl-paragraph-spacing": 0,
    "alias-font-display-serif-2xl-text-decoration": "none",
    "alias-font-display-serif-2xl-text-case": "none",
    "alias-font-display-serif-xl-font-family": "{core-font-family-serif}",
    "alias-font-display-serif-xl-font-weight": "{core-font-weight-1-base}",
    "alias-font-display-serif-xl-line-height": "{core-line-height-heading}",
    "alias-font-display-serif-xl-font-size": "{core-font-size-4xl}",
    "alias-font-display-serif-xl-letter-spacing": "0%",
    "alias-font-display-serif-xl-paragraph-spacing": 0,
    "alias-font-display-serif-xl-text-decoration": "none",
    "alias-font-display-serif-xl-text-case": "none",
    "alias-font-display-serif-lg-font-family": "{core-font-family-serif}",
    "alias-font-display-serif-lg-font-weight": "{core-font-weight-1-base}",
    "alias-font-display-serif-lg-line-height": "{core-line-height-heading}",
    "alias-font-display-serif-lg-font-size": "{core-font-size-3xl}",
    "alias-font-display-serif-lg-letter-spacing": "0%",
    "alias-font-display-serif-lg-paragraph-spacing": 0,
    "alias-font-display-serif-lg-text-decoration": "none",
    "alias-font-display-serif-lg-text-case": "none",
    "alias-font-display-serif-md-font-family": "{core-font-family-serif}",
    "alias-font-display-serif-md-font-weight": "{core-font-weight-2-base}",
    "alias-font-display-serif-md-line-height": "{core-line-height-heading}",
    "alias-font-display-serif-md-font-size": "{core-font-size-2xl}",
    "alias-font-display-serif-md-letter-spacing": "0%",
    "alias-font-display-serif-md-paragraph-spacing": 0,
    "alias-font-display-serif-md-text-decoration": "none",
    "alias-font-display-serif-md-text-case": "none",
    "alias-font-display-serif-sm-font-family": "{core-font-family-serif}",
    "alias-font-display-serif-sm-font-weight": "{core-font-weight-2-base}",
    "alias-font-display-serif-sm-line-height": "{core-line-height-heading}",
    "alias-font-display-serif-sm-font-size": "{core-font-size-lg}",
    "alias-font-display-serif-sm-letter-spacing": "0%",
    "alias-font-display-serif-sm-paragraph-spacing": 0,
    "alias-font-display-serif-sm-text-decoration": "none",
    "alias-font-display-serif-sm-text-case": "none",
    "alias-font-body-md-base-font-family": "{core-font-family-sans}",
    "alias-font-body-md-base-font-weight": "{core-font-weight-1-base}",
    "alias-font-body-md-base-line-height": "{core-line-height-body-md}",
    "alias-font-body-md-base-font-size": "{core-font-size-base}",
    "alias-font-body-md-base-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-body-md-base-paragraph-spacing": 0,
    "alias-font-body-md-base-text-decoration": "none",
    "alias-font-body-md-base-text-case": "none",
    "alias-font-body-md-bold-font-family": "{core-font-family-sans}",
    "alias-font-body-md-bold-font-weight": "{core-font-weight-2-base}",
    "alias-font-body-md-bold-line-height": "{core-line-height-body-md}",
    "alias-font-body-md-bold-font-size": "{core-font-size-base}",
    "alias-font-body-md-bold-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-body-md-bold-paragraph-spacing": 0,
    "alias-font-body-md-bold-text-decoration": "none",
    "alias-font-body-md-bold-text-case": "none",
    "alias-font-body-md-italic-font-family": "{core-font-family-sans}",
    "alias-font-body-md-italic-font-weight": "{core-font-weight-1-italic}",
    "alias-font-body-md-italic-line-height": "{core-line-height-body-md}",
    "alias-font-body-md-italic-font-size": "{core-font-size-base}",
    "alias-font-body-md-italic-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-body-md-italic-paragraph-spacing": 0,
    "alias-font-body-md-italic-text-decoration": "none",
    "alias-font-body-md-italic-text-case": "none",
    "alias-font-body-lg-base-font-family": "{core-font-family-sans}",
    "alias-font-body-lg-base-font-weight": "{core-font-weight-1-base}",
    "alias-font-body-lg-base-line-height": "{core-line-height-body-lg}",
    "alias-font-body-lg-base-font-size": "{core-font-size-lg}",
    "alias-font-body-lg-base-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-body-lg-base-paragraph-spacing": 0,
    "alias-font-body-lg-base-text-decoration": "none",
    "alias-font-body-lg-base-text-case": "none",
    "alias-font-body-lg-bold-font-family": "{core-font-family-sans}",
    "alias-font-body-lg-bold-font-weight": "{core-font-weight-2-base}",
    "alias-font-body-lg-bold-line-height": "{core-line-height-body-lg}",
    "alias-font-body-lg-bold-font-size": "{core-font-size-lg}",
    "alias-font-body-lg-bold-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-body-lg-bold-paragraph-spacing": 0,
    "alias-font-body-lg-bold-text-decoration": "none",
    "alias-font-body-lg-bold-text-case": "none",
    "alias-font-body-lg-italic-font-family": "{core-font-family-sans}",
    "alias-font-body-lg-italic-font-weight": "{core-font-weight-1-italic}",
    "alias-font-body-lg-italic-line-height": "{core-line-height-body-lg}",
    "alias-font-body-lg-italic-font-size": "{core-font-size-lg}",
    "alias-font-body-lg-italic-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-body-lg-italic-paragraph-spacing": 0,
    "alias-font-body-lg-italic-text-decoration": "none",
    "alias-font-body-lg-italic-text-case": "none",
    "alias-font-body-sm-base-font-family": "{core-font-family-sans}",
    "alias-font-body-sm-base-font-weight": "{core-font-weight-1-base}",
    "alias-font-body-sm-base-line-height": "{core-line-height-body-sm}",
    "alias-font-body-sm-base-font-size": "{core-font-size-sm}",
    "alias-font-body-sm-base-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-body-sm-base-paragraph-spacing": 0,
    "alias-font-body-sm-base-text-decoration": "none",
    "alias-font-body-sm-base-text-case": "none",
    "alias-font-body-sm-bold-font-family": "{core-font-family-sans}",
    "alias-font-body-sm-bold-font-weight": "{core-font-weight-2-base}",
    "alias-font-body-sm-bold-line-height": "{core-line-height-body-sm}",
    "alias-font-body-sm-bold-font-size": "{core-font-size-sm}",
    "alias-font-body-sm-bold-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-body-sm-bold-paragraph-spacing": 0,
    "alias-font-body-sm-bold-text-decoration": "none",
    "alias-font-body-sm-bold-text-case": "none",
    "alias-font-body-sm-italic-font-family": "{core-font-family-sans}",
    "alias-font-body-sm-italic-font-weight": "{core-font-weight-1-italic}",
    "alias-font-body-sm-italic-line-height": "{core-line-height-body-sm}",
    "alias-font-body-sm-italic-font-size": "{core-font-size-sm}",
    "alias-font-body-sm-italic-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-body-sm-italic-paragraph-spacing": 0,
    "alias-font-body-sm-italic-text-decoration": "none",
    "alias-font-body-sm-italic-text-case": "none",
    "alias-font-label-base-strong-font-family": "{core-font-family-sans}",
    "alias-font-label-base-strong-font-weight": "{core-font-weight-2-base}",
    "alias-font-label-base-strong-line-height": "{core-line-height-label}",
    "alias-font-label-base-strong-font-size": "{core-font-size-sm}",
    "alias-font-label-base-strong-letter-spacing": "{core-letter-spacing-base}",
    "alias-font-label-base-strong-paragraph-spacing": 0,
    "alias-font-label-base-strong-text-decoration": "none",
    "alias-font-label-base-strong-text-case": "none",
    "alias-font-label-base-weak-font-family": "{core-font-family-sans}",
    "alias-font-label-base-weak-font-weight": "{core-font-weight-1-base}",
    "alias-font-label-base-weak-line-height": "{core-line-height-label}",
    "alias-font-label-base-weak-font-size": "{core-font-size-sm}",
    "alias-font-label-base-weak-letter-spacing": "{core-letter-spacing-base}",
    "alias-font-label-base-weak-paragraph-spacing": 0,
    "alias-font-label-base-weak-text-decoration": "none",
    "alias-font-label-base-weak-text-case": "none",
    "alias-font-label-base-weak-underline-font-family": "{core-font-family-sans}",
    "alias-font-label-base-weak-underline-font-weight": "{core-font-weight-1-base}",
    "alias-font-label-base-weak-underline-line-height": "{core-line-height-label}",
    "alias-font-label-base-weak-underline-font-size": "{core-font-size-sm}",
    "alias-font-label-base-weak-underline-letter-spacing": "{core-letter-spacing-base}",
    "alias-font-label-base-weak-underline-paragraph-spacing": 0,
    "alias-font-label-base-weak-underline-text-decoration": "{core-text-decoration-underline}",
    "alias-font-label-base-weak-underline-text-case": "none",
    "alias-font-label-base-strong-underline-font-family": "{core-font-family-sans}",
    "alias-font-label-base-strong-underline-font-weight": "{core-font-weight-2-base}",
    "alias-font-label-base-strong-underline-line-height": "{core-line-height-label}",
    "alias-font-label-base-strong-underline-font-size": "{core-font-size-sm}",
    "alias-font-label-base-strong-underline-letter-spacing": "{core-letter-spacing-base}",
    "alias-font-label-base-strong-underline-paragraph-spacing": 0,
    "alias-font-label-base-strong-underline-text-decoration": "{core-text-decoration-underline}",
    "alias-font-label-base-strong-underline-text-case": "none",
    "alias-font-label-lg-strong-font-family": "{core-font-family-sans}",
    "alias-font-label-lg-strong-font-weight": "{core-font-weight-2-base}",
    "alias-font-label-lg-strong-line-height": "{core-line-height-label}",
    "alias-font-label-lg-strong-font-size": "{core-font-size-base}",
    "alias-font-label-lg-strong-letter-spacing": "{core-letter-spacing-base}",
    "alias-font-label-lg-strong-paragraph-spacing": 0,
    "alias-font-label-lg-strong-text-decoration": "none",
    "alias-font-label-lg-strong-text-case": "none",
    "alias-font-label-lg-weak-font-family": "{core-font-family-sans}",
    "alias-font-label-lg-weak-font-weight": "{core-font-weight-1-base}",
    "alias-font-label-lg-weak-line-height": "{core-line-height-label}",
    "alias-font-label-lg-weak-font-size": "{core-font-size-base}",
    "alias-font-label-lg-weak-letter-spacing": "{core-letter-spacing-base}",
    "alias-font-label-lg-weak-paragraph-spacing": 0,
    "alias-font-label-lg-weak-text-decoration": "none",
    "alias-font-label-lg-weak-text-case": "none",
    "alias-font-label-lg-weak-underline-font-family": "{core-font-family-sans}",
    "alias-font-label-lg-weak-underline-font-weight": "{core-font-weight-1-base}",
    "alias-font-label-lg-weak-underline-line-height": "{core-line-height-label}",
    "alias-font-label-lg-weak-underline-font-size": "{core-font-size-base}",
    "alias-font-label-lg-weak-underline-letter-spacing": "{core-letter-spacing-base}",
    "alias-font-label-lg-weak-underline-paragraph-spacing": 0,
    "alias-font-label-lg-weak-underline-text-decoration": "{core-text-decoration-underline}",
    "alias-font-label-lg-weak-underline-text-case": "none",
    "alias-font-label-lg-strong-underline-font-family": "{core-font-family-sans}",
    "alias-font-label-lg-strong-underline-font-weight": "{core-font-weight-2-base}",
    "alias-font-label-lg-strong-underline-line-height": "{core-line-height-label}",
    "alias-font-label-lg-strong-underline-font-size": "{core-font-size-base}",
    "alias-font-label-lg-strong-underline-letter-spacing": "{core-letter-spacing-base}",
    "alias-font-label-lg-strong-underline-paragraph-spacing": 0,
    "alias-font-label-lg-strong-underline-text-decoration": "{core-text-decoration-underline}",
    "alias-font-label-lg-strong-underline-text-case": "none",
    "alias-font-caption-lg-base-font-family": "{core-font-family-sans}",
    "alias-font-caption-lg-base-font-weight": "{core-font-weight-1-base}",
    "alias-font-caption-lg-base-line-height": "{core-line-height-caption}",
    "alias-font-caption-lg-base-font-size": "{core-font-size-xs}",
    "alias-font-caption-lg-base-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-caption-lg-base-paragraph-spacing": 0,
    "alias-font-caption-lg-base-text-decoration": "none",
    "alias-font-caption-lg-base-text-case": "none",
    "alias-font-caption-lg-bold-font-family": "{core-font-family-sans}",
    "alias-font-caption-lg-bold-font-weight": "{core-font-weight-2-base}",
    "alias-font-caption-lg-bold-line-height": "{core-line-height-caption}",
    "alias-font-caption-lg-bold-font-size": "{core-font-size-xs}",
    "alias-font-caption-lg-bold-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-caption-lg-bold-paragraph-spacing": 0,
    "alias-font-caption-lg-bold-text-decoration": "none",
    "alias-font-caption-lg-bold-text-case": "none",
    "alias-font-caption-sm-base-font-family": "{core-font-family-sans}",
    "alias-font-caption-sm-base-font-weight": "{core-font-weight-1-base}",
    "alias-font-caption-sm-base-line-height": "{core-line-height-caption}",
    "alias-font-caption-sm-base-font-size": "{core-font-size-xxs}",
    "alias-font-caption-sm-base-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-caption-sm-base-paragraph-spacing": 0,
    "alias-font-caption-sm-base-text-decoration": "none",
    "alias-font-caption-sm-base-text-case": "none",
    "alias-font-caption-sm-bold-font-family": "{core-font-family-sans}",
    "alias-font-caption-sm-bold-font-weight": "{core-font-weight-2-base}",
    "alias-font-caption-sm-bold-line-height": "{core-line-height-caption}",
    "alias-font-caption-sm-bold-font-size": "{core-font-size-xxs}",
    "alias-font-caption-sm-bold-letter-spacing": "{core-letter-spacing-wide}",
    "alias-font-caption-sm-bold-paragraph-spacing": 0,
    "alias-font-caption-sm-bold-text-decoration": "none",
    "alias-font-caption-sm-bold-text-case": "none",
    "alias-font-overline-font-family": "{core-font-family-sans}",
    "alias-font-overline-font-weight": "{core-font-weight-2-base}",
    "alias-font-overline-line-height": "{core-line-height-caption}",
    "alias-font-overline-font-size": "{core-font-size-xs}",
    "alias-font-overline-letter-spacing": "{core-letter-spacing-widest}",
    "alias-font-overline-paragraph-spacing": 0,
    "alias-font-overline-text-decoration": "none",
    "alias-font-overline-text-case": "{core-letter-case-uppercase}",
    "alias-state-primary-hover": "{core-color-teal-90}",
    "alias-state-primary-pressed": "{core-color-teal-90}",
    "alias-state-primary-active": "{core-color-teal-90}",
    "alias-state-secondary-hover": "{core-color-light-blue-20}",
    "alias-state-secondary-pressed": "{core-color-light-blue-20}",
    "alias-state-tertiary-hover": "#D7DCF2",
    "alias-state-tertiary-pressed": "#CCD2EA",
    "alias-state-base-hover": "rgba({core-color-slate-100},0.03)",
    "alias-state-base-pressed": "rgba({core-color-slate-100},0.06)",
    "alias-state-base-active": "rgba({core-color-slate-100},0.03)",
    "alias-state-destructive-hover": "rgba({core-color-red-60},0.05)",
    "alias-state-destructive-pressed": "rgba({core-color-red-60},0.08)",
    "alias-state-success-hover": "{core-color-green-70}",
    "alias-state-success-pressed": "{core-color-green-70}",
    "alias-size-input-sm": "{core-size-base}",
    "alias-size-input-md": "{core-size-3xl}",
    "alias-size-input-lg": "{core-size-4xl}",
    "alias-size-action-sm": "{core-size-2xl}",
    "alias-size-action-md": "{core-size-3xl}",
    "alias-size-action-lg": "{core-size-4xl}",
    "alias-size-action-xl": "{core-size-5xl}",
    "alias-size-menu-part-sm": "{core-size-2xl}",
    "alias-size-menu-part-md": "{core-size-3xl}",
    "alias-size-menu-part-lg": "{core-size-4xl}",
    "alias-size-menu-part-xl": "{core-size-5xl}",
    "alias-size-field-sm": "{core-size-3xl}",
    "alias-size-field-md": "{core-size-5xl}",
    "alias-size-field-lg": "{core-size-7xl}",
    "alias-space-text-with-icon-sm": "{core-space-xxs}",
    "alias-space-text-with-icon-md": "{core-space-xs}",
    "alias-space-text-with-icon-lg": "{core-space-sm}",
    "alias-space-button-group-xs": "{core-space-xxs}",
    "alias-space-button-group-sm": "{core-space-xs}",
    "alias-space-button-group-md": "{core-space-sm}",
    "alias-space-button-group-lg": "{core-space-base}",
    "alias-space-form-items-horizontal": "{core-space-base}",
    "alias-space-form-items-vertical": "{core-space-lg}",
    "alias-space-title-with-text-sm": "{core-space-xxxs}",
    "alias-space-title-with-text-md": "{core-space-xxs}",
    "alias-space-title-with-text-lg": "{core-space-xs}",
    "alias-space-title-with-text-xl": "{core-space-base}",
    "alias-space-label-with-text-base": "{core-space-xxs}",
    "alias-space-label-with-text-tight": "{core-space-xxxs}",
    "alias-space-toolbar-tight": "{core-space-xs}",
    "alias-space-toolbar-base": "{core-space-base}",
    "alias-space-toolbar-wide": "{core-space-xl}",
    "alias-padding-base": "{core-space-lg}",
    "alias-padding-sm": "{core-space-base}",
    "alias-padding-xs": "{core-space-sm}",
    "alias-padding-xxs": "{core-space-xs}",
    "alias-padding-xxxs": "{core-space-xxs}",
    "alias-padding-action-sm-base": "{core-space-xs}",
    "alias-padding-action-sm-tight": "{core-space-xxs}",
    "alias-padding-action-md-base": "{core-space-sm}",
    "alias-padding-action-md-tight": "{core-space-xs}",
    "alias-padding-action-lg-base": "{core-space-base}",
    "alias-padding-action-lg-tight": "{core-space-sm}",
    "alias-border-width-default": "{core-border-width-1}",
    "alias-border-width-pressed": "{core-border-width-2}",
    "alias-border-width-active": "{core-border-width-3}",
    "alias-height-label": "{core-line-height-label}",
    "alias-menu-part-padding-base": "{core-space-sm}",
    "alias-menu-part-padding-tight": "{core-space-xxs}",
    "alias-menu-part-padding-wide": "{core-space-3xl}",
    "alias-menu-part-space": "{alias-space-text-with-icon-md}",
    "alias-filter-backdrop-brightness-base-hover": "{core-filter-backdrop-brightness-darken-1}",
    "alias-filter-backdrop-brightness-base-pressed": "{core-filter-backdrop-brightness-darken-2}",
    "alias-layout-padding-sm": "{core-space-lg}",
    "alias-layout-padding-md": "{core-space-2xl}",
    "alias-layout-padding-lg": "{core-space-2xl}",
    "alias-layout-padding-xl": "{core-space-2xl}",
    "alias-layout-padding-2xl": "{core-space-2xl}",
    "component-input-group-space-tight": "{core-space-xxs}",
    "component-input-group-space-base": "{core-space-xs}",
    "component-input-group-space-wide": "{core-space-base}",
    "component-button-sm-padding-base": "{core-space-lg}",
    "component-button-sm-padding-tight": "{core-space-base}",
    "component-button-height-sm": "{alias-size-action-md}",
    "component-button-height-md": "{alias-size-action-lg}",
    "component-button-height-lg": "{alias-size-action-xl}",
    "component-button-md-padding-base": "{core-space-xl}",
    "component-button-md-padding-tight": "{core-space-lg}",
    "component-button-lg-padding-base": "{core-space-2xl}",
    "component-button-lg-padding-tight": "28px",
    "component-button-border-radius-pill": "{alias-border-radius-pill}",
    "component-button-border-radius-round": "{core-border-radius-xs}",
    "component-button-border-width-default": "{alias-border-width-default}",
    "component-button-border-width-active": "{alias-border-width-active}",
    "component-button-space": "{alias-space-text-with-icon-md}",
    "component-icon-size-xs": "{core-size-xs}",
    "component-icon-size-sm": "{core-size-sm}",
    "component-icon-size-base": "{core-size-base}",
    "component-icon-size-lg": "{core-size-lg}",
    "component-icon-size-xl": "{core-size-xl}",
    "component-icon-size-2xl": "{core-size-2xl}",
    "component-icon-border-width-2xl": 3.2,
    "component-icon-border-width-xl": 2.4,
    "component-icon-border-width-lg": 2,
    "component-icon-border-width-base": 1.6,
    "component-icon-border-width-sm": 1.2,
    "component-icon-border-width-xs": 0.8,
    "component-text-input-padding-base": "{core-space-sm}",
    "component-text-input-padding-tight": "{core-space-xxs}",
    "component-text-input-color-text-default": "{alias-color-text-weak}",
    "component-text-input-color-text-hover": "{alias-color-text-weak}",
    "component-text-input-color-text-active": "{alias-color-text-base}",
    "component-text-input-color-text-complete": "{alias-color-text-base}",
    "component-text-input-color-text-disabled": "{alias-color-text-disabled}",
    "component-text-input-height": "{alias-size-input-md}",
    "component-text-input-space": "{alias-space-text-with-icon-lg}",
    "component-text-input-border-width-default": "{core-border-width-1}",
    "component-text-input-border-width-pressed": "{core-border-width-2}",
    "component-text-input-border-width-active": "{core-border-width-3}",
    "component-text-input-border-radius": "{core-border-radius-xs}",
    "component-text-input-margin-base": "{core-space-xs}",
    "component-badge-padding-base": "{core-space-sm}",
    "component-badge-padding-tight": "{core-space-xs}",
    "component-badge-height-lg": "{core-size-xl}",
    "component-badge-height-sm": "{core-size-lg}",
    "component-badge-space": "{alias-space-text-with-icon-sm}",
    "component-badge-border-radius-pill": "{alias-border-radius-pill}",
    "component-badge-border-radius-round": "{core-border-radius-xs}",
    "component-badge-border-width": "{core-border-width-1}",
    "component-avatar-size-sm": "{core-size-xl}",
    "component-avatar-size-md": "{core-size-2xl}",
    "component-avatar-size-lg": "{core-size-3xl}",
    "component-avatar-size-xl": "{core-size-4xl}",
    "component-avatar-size-2xl": "{core-size-5xl}",
    "component-avatar-border-radius": "{alias-border-radius-circle}",
    "component-table-cell-size-header": "{core-size-4xl}",
    "component-table-cell-size-single-line": "{core-size-5xl}",
    "component-table-cell-size-multi-line": "{core-size-7xl}",
    "component-table-cell-padding-tighter": "{core-space-sm}",
    "component-table-cell-padding-tight": "{alias-padding-sm}",
    "component-table-cell-padding-base": "{alias-padding-base}",
    "component-table-cell-space-tight": "{core-space-sm}",
    "component-table-cell-space-base": "{core-space-base}",
    "component-table-cell-space-wide": "{core-space-lg}",
    "component-table-cell-space-none": "{core-space-none}",
    "component-table-cell-spacing-vertical": "{alias-space-title-with-text-sm}",
    "component-table-cell-spacing-horizontal": "{alias-space-text-with-icon-sm}",
    "component-sidebar-space": "{core-space-base}",
    "component-sidebar-padding-x": "{alias-padding-xxs}",
    "component-sidebar-padding-y": "{alias-padding-xs}",
    "component-dropdown-menu-padding": "{core-space-xs}",
    "component-dropdown-menu-border-radius": "{core-border-radius-sm}",
    "component-simple-button-padding-base": "{alias-padding-action-sm-base}",
    "component-simple-button-padding-tight": "{alias-padding-action-sm-tight}",
    "component-simple-button-height": "{alias-size-action-sm}",
    "component-simple-button-space-base": "{alias-space-text-with-icon-sm}",
    "component-alert-padding-tight": "{alias-padding-xxs}",
    "component-alert-padding-base": "{alias-padding-xs}",
    "component-alert-border-radius-sm": "{core-border-radius-xs}",
    "component-alert-border-radius-lg": "{core-border-radius-xs}",
    "component-alert-space-base": "{core-space-xs}",
    "component-alert-space-wide": "{core-space-sm}",
    "component-checkbox-size": "{alias-size-input-sm}",
    "component-checkbox-border-radius": "{core-border-radius-xxs}",
    "component-checkbox-border-width-default": "{core-border-width-2}",
    "component-checkbox-border-width-active": "{core-border-width-2}",
    "component-checkbox-space-base": "{alias-space-text-with-icon-md}",
    "component-checkbox-space-wide": "{core-space-sm}",
    "component-checkbox-space-tight": "{alias-space-title-with-text-md}",
    "component-radio-size": "{alias-size-input-sm}",
    "component-radio-border-radius": "{alias-border-radius-circle}",
    "component-radio-space-base": "{alias-space-text-with-icon-md}",
    "component-radio-space-wide": "{core-space-sm}",
    "component-radio-space-tight": "{alias-space-title-with-text-md}",
    "component-radio-border-width": "{core-border-width-2}",
    "component-menu-item-height-sm": "{alias-size-menu-part-md}",
    "component-menu-item-height-md": "{alias-size-menu-part-lg}",
    "component-menu-item-height-lg": "{alias-size-menu-part-xl}",
    "component-menu-item-border-radius": "{core-border-radius-xs}",
    "component-extra-height": "{core-size-2xl}",
    "component-extra-padding": "{core-space-sm}",
    "component-extra-border-radius": "{core-border-radius-xxs}",
    "component-extra-border-width-weak": "{core-border-width-0}",
    "component-extra-border-width-strong": "{core-border-width-1}",
    "component-tab-height": "{alias-size-action-md}",
    "component-tab-padding-base": "{alias-padding-action-md-base}",
    "component-tab-padding-tight": "{alias-padding-action-md-tight}",
    "component-tab-border-radius": "{core-border-radius-xs}",
    "component-tab-space": "{alias-space-text-with-icon-md}",
    "component-tab-border-width-default": "{core-border-width-1}",
    "component-tab-border-width-hover": "{core-border-width-3}",
    "component-tab-border-width-pressed": "{core-border-width-3}",
    "component-tab-border-width-active": "{core-border-width-3}",
    "component-step-height-single-line": "{alias-size-action-md}",
    "component-step-height-multi-line": "{alias-size-action-xl}",
    "component-step-padding": "{core-space-sm}",
    "component-step-space": "{alias-space-text-with-icon-lg}",
    "component-step-border-radius": "{core-border-radius-xs}",
    "component-tab-group-space-pill": "{core-space-xs}",
    "component-tab-group-space-border": "{core-space-xl}",
    "component-description-list-height": "{alias-size-field-md}",
    "component-description-list-padding-vertical": "{alias-padding-xxs}",
    "component-description-list-spacing-horizontal": "{alias-space-title-with-text-xl}",
    "component-description-list-spacing-vertical-view": "{component-input-group-space-tight}",
    "component-description-list-spacing-vertical-edit": "{component-input-group-space-base}",
    "component-card-padding-base": "{core-space-xl}",
    "component-card-padding-tight": "{core-space-lg}",
    "component-card-padding-tighter": "{core-space-sm}",
    "component-card-padding-none": "{core-space-none}",
    "component-card-border-width": "{core-border-width-1}",
    "component-card-border-radius-base": "{core-border-radius-sm}",
    "component-card-space-lg": "{core-space-xl}",
    "component-card-space-sm": "{core-space-lg}",
    "component-step-indicator-border-width": "{core-border-width-2}",
    "component-step-indicator-border-radius": "{alias-border-radius-circle}",
    "component-step-indicator-size": "{alias-size-input-sm}",
    "component-step-group-space": "{core-space-xs}",
    "component-breadcrumbs-space": "{core-space-xxs}",
    "component-menu-header-height": "{alias-size-menu-part-sm}",
    "component-topbar-height": "{core-size-8xl}",
    "component-topbar-padding": "{alias-layout-padding-lg}",
    "component-topbar-space": "{core-space-base}",
    "component-page-margin-base": "{core-space-2xl}",
    "component-pagination-bar-height": "{core-size-6xl}",
    "component-pagination-bar-space-base": "{core-space-base}",
    "component-pagination-bar-space-wide": "{core-space-lg}",
    "component-pagination-bar-space-wider": "{core-space-xl}",
    "component-radio-card-border-width-default": "{core-border-width-2}",
    "component-radio-card-border-width-active": "{core-border-width-2}",
    "component-radio-card-border-radius": "{core-border-radius-md}",
    "component-radio-card-padding-base": "{core-space-base}",
    "component-radio-card-space-base": "{core-space-xxxs}",
    "component-snackbar-padding-base": "{core-space-sm}",
    "component-snackbar-padding-tight": "{core-space-xs}",
    "component-file-upload-padding": "{core-space-lg}",
    "component-file-upload-space-tight": "{core-space-xxs}",
    "component-file-upload-space-base": "{core-space-xs}",
    "component-file-upload-border-radius": "{core-border-radius-sm}",
    "component-file-upload-border-width": "{core-border-width-1}",
    "component-file-padding": "{core-space-base}",
    "component-file-space-base": "{core-space-sm}",
    "component-file-space-tight": "{core-space-xxs}",
    "component-file-border-radius": "{core-border-radius-md}",
    "component-file-border-width": "{core-border-width-1}",
    "component-toggle-border-radius": "{alias-border-radius-pill}",
    "component-toggle-space-base": "{core-space-xs}",
    "component-toggle-height": "{core-size-lg}",
    "component-toggle-width": "2.25rem",
    "component-toggle-padding-base": "{core-space-xxxs}",
    "component-toggle-padding-hover": "{core-space-xxs}",
    "component-toggle-padding-pressed": "{core-space-xxs}",
    "component-segmented-buttons-border-radius": "{core-border-radius-xs}",
    "component-segmented-buttons-border-width": "{core-border-width-1}",
    "component-segmented-buttons-height-md": "{alias-size-action-md}",
    "component-segmented-buttons-space-base": "{alias-padding-sm}",
    "component-dropdown-space": "{core-space-xs}",
    "component-radio-card-group-space-base": "{core-space-xs}",
    "component-accordian-padding-base": "{core-space-xs}",
    "component-accordian-space-base": "{core-space-xs}",
    "component-input-text-group-space-base": "{alias-space-title-with-text-md}",
    "component-input-text-group-space-tight": "{alias-space-title-with-text-sm}",
    "component-input-text-group-space-wide": "{alias-space-title-with-text-lg}",
    "component-icon-button-size-xs": "{core-size-2xl}",
    "component-icon-button-size-sm": "{core-size-3xl}",
    "component-icon-button-size-md": "{core-size-4xl}",
    "component-icon-button-size-lg": "{core-size-5xl}",
    "component-icon-button-border-radius-circle": "{alias-border-radius-circle}",
    "component-icon-button-border-width-base": "{alias-border-width-default}",
    "component-icon-button-border-width-active": "{alias-border-width-active}",
    "component-scrollbar-color-base": "rgba({core-color-slate-100},0.30)",
    "component-scrollbar-color-border": "rgba({core-color-neutral-white},0.30)",
    "component-scrollbar-color-hover": "rgba({core-color-slate-100},0.50)",
    "component-container-space-none": "{core-space-none}",
    "component-container-space-tightest": "{core-space-xxs}",
    "component-container-space-tighter": "{core-space-xs}",
    "component-container-space-tight": "{core-space-sm}",
    "component-container-space-base": "{core-space-base}",
    "component-container-space-wide": "{core-space-lg}",
    "component-container-space-wider": "{core-space-xl}",
    "component-container-space-widest": "{core-space-2xl}",
    "component-user-dropdown-space-base": "{core-space-base}",
    "component-user-dropdown-space-tight": "{core-space-xs}",
    "component-anchor-link-item-height-md": "{core-size-xl}",
    "component-anchor-link-item-space-base": "{core-space-base}",
    "component-anchor-link-item-space-wide": "{core-space-xl}",
    "component-anchor-link-item-border-width-hover": "{core-border-width-3}",
    "component-anchor-link-item-border-width-pressed": "{core-border-width-3}",
    "component-anchor-link-item-border-width-active": "{core-border-width-3}",
    "component-anchor-link-item-padding-vertical-base": "{alias-padding-xxxs}",
    "component-segmentted-button-space-base": "{alias-padding-sm}",
    "component-rich-text-editor-contained-space-tight": "{alias-padding-xxxs}",
    "component-rich-text-editor-contained-border-radius-base": "{core-border-radius-xs}",
    "component-rich-text-editor-contained-border-width-default": "{alias-border-width-default}",
    "component-list-item-sm-padding-vertical-base": "{alias-padding-xxs}",
    "component-list-item-padding-horizontal-base": "{alias-padding-xs}",
    "component-list-item-padding-horizontal-indent": "{core-space-3xl}",
    "component-list-item-md-padding-vertical-base": "{alias-padding-xs}",
    "component-list-item-lg-padding-vertical-base": "{alias-padding-sm}",
    "component-overlay-color-light-base": "{alias-color-bg-alt}",
    "component-overlay-color-dark-base": "{core-color-slate-100}"
};
